/* eslint-disable */

import { Col, Divider, Form, Image, Input, InputNumber, Row, Select, Typography, Upload, message } from "antd";
import React, { useState } from "react";
import { ImagePreview, UploadButton, createHandlePreview, createHandleUpload } from "../../utils/uploadUtils.jsx";

import { useTranslation } from "react-i18next";
import permissions from "../../../configs/permission";
import { usePermission } from "../../hooks/usePermission";

const { TextArea } = Input;
const { Title } = Typography;
const { Dragger } = Upload;

export const CreateDestinationPackageDetail = ({ t, formDestinationPackage, type, setFileList, fileList }) => {
  const { hasPermission, isSuperuser } = usePermission();
  /** แก้ไข package ในโหมด EDIT ใช้แค่ CHANGE (สอดคล้องปุ่ม Save ในหน้า create) — ไม่บังคับ ADD */
  const isReadOnlyByPermission =
    type === "EDIT" && !isSuperuser && !hasPermission(permissions.DestinationPackage.CHANGE);
  const canViewDestinationPackageImages =
    hasPermission(permissions.DestinationPackageImage.VIEW) ||
    hasPermission(permissions.DestinationPackageImage.ADD) ||
    hasPermission(permissions.DestinationPackageImage.CHANGE) ||
    hasPermission(permissions.DestinationPackageImage.DELETE);
  /** โหมด EDIT อนุญาตทั้ง ADD หรือ CHANGE (บาง role มีแค่ข้างใดข้างหนึ่งใน JWT) */
  const canUploadDestinationPackageImages =
    (type === "CREATE" && hasPermission(permissions.DestinationPackageImage.ADD)) ||
    (type === "EDIT" &&
      (hasPermission(permissions.DestinationPackageImage.CHANGE) ||
        hasPermission(permissions.DestinationPackageImage.ADD)));
  /** เปิด Upload list ใน EDIT เมื่อมีสิทธิ์ลบรูปด้วย (ไม่ปิดทั้งคอมโพเนนต์เมื่อมีแค่ DELETE) */
  const canInteractWithDestinationPackageImageUpload =
    canUploadDestinationPackageImages || (type === "EDIT" && hasPermission(permissions.DestinationPackageImage.DELETE));
  const [messageApi, contextHolder] = message.useMessage();
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };
  /* eslint-enable no-template-curly-in-string */
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const originPackageWeightType = [
    { value: "normal", label: tOps("Weight_Type.Normal") },
    { value: "mixed", label: tOps("Weight_Type.Mixed") },
  ];

  const originPackageType = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
  ];

  const packageStatus = [
    { value: "0", label: tOps("Package_Status.At_The_Origin_Warehouse") },
    { value: "1", label: tOps("Package_Status.Transporting_To_The_Destination_Warehouse") },
    { value: "2", label: tOps("Package_Status.At_The_Destination_Warehouse") },
    { value: "3", label: tOps("Package_Status.Delivered") },
  ];

  const handleUpload = createHandleUpload(messageApi);
  const handlePreview = createHandlePreview(setPreviewImage, setPreviewOpen);

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadButton = <UploadButton />;

  return (
    <>
      {contextHolder}
      <Row align="top" justify="center">
        <Col span={12}>
          <Row gutter={10}>
            <Col flex={6}>
              <Form
                form={formDestinationPackage}
                labelAlign="left"
                labelCol={{ flex: "200px" }}
                disabled={isReadOnlyByPermission}
              >
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Description") + ":"}
                    name="package_description"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                  >
                    <Input size="default" placeholder={"description"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Type") + ":"}
                    name="package_type"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select style={{ width: "100%" }} options={originPackageType} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Package_Status") + ":"}
                    name="package_status"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select style={{ width: "100%" }} options={packageStatus} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Total_Received") + ":"}
                    name="total_received"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Length") + ":"}
                    name="length"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Width") + ":"}
                    name="width"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Weight") + ":"}
                    name="weight"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"kg"} step="1.000000" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Volume") + ":"}
                    name="volume"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} addonAfter={"kg"} step="1.000000" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Height") + ":"}
                    name="height"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} min={1} addonAfter={"cm"} step="1.00" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Weight_Type") + ":"}
                    name="weight_type"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select style={{ width: "100%" }} options={originPackageWeightType} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Amount") + ":"}
                    name="amount"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Total_Count") + ":"}
                    name="total_count"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Total_Amount") + ":"}
                    name="total_amount"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Total_Volume") + ":"}
                    name="total_volume"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t("Detail_Page.Tab_Detail.Total_Weight") + ":"}
                    name="total_weight"
                    style={{ marginBottom: "1rem" }}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Divider />
              </Form>
            </Col>
            <Col flex={1}></Col>
          </Row>
        </Col>
        {canViewDestinationPackageImages && (
          <Col span={12}>
            <Row gutter={10} style={{ justifyContent: "left", alignSelf: "baseline" }}>
              <Col span={24}>
                {`สามารถอัปโหลดรูปภาพได้สูงสุด 8 รูป`}
                <Upload
                  customRequest={handleUpload}
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}
                  maxCount={8}
                  disabled={!canInteractWithDestinationPackageImageUpload}
                  onRemove={() => {
                    const canRemove =
                      hasPermission(permissions.DestinationPackageImage.DELETE) ||
                      hasPermission(permissions.DestinationPackageImage.ADD) ||
                      hasPermission(permissions.DestinationPackageImage.CHANGE);
                    if (!canRemove) {
                      message.warning("You are not allowed to remove this file.");
                      return false;
                    }
                  }}
                >
                  {fileList.length >= 8 || !canUploadDestinationPackageImages ? null : uploadButton}
                </Upload>
                <ImagePreview
                  previewImage={previewImage}
                  previewOpen={previewOpen}
                  setPreviewOpen={setPreviewOpen}
                  setPreviewImage={setPreviewImage}
                  Image={Image}
                />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};
